module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Locatiestickers"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Locatiestickers PDF generator")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Rijnummer"
    }
  }, [_vm._v("Letter:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.letter),
      expression: "letter"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "placeholder": "A"
    },
    domProps: {
      "value": (_vm.letter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.letter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Rijnummer"
    }
  }, [_vm._v("Rijnummer:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rowNumber),
      expression: "rowNumber"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "Nummber",
      "placeholder": "05"
    },
    domProps: {
      "value": (_vm.rowNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rowNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.rowNumber && _vm.letter) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.letter))]), _vm._v(".\n                          "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.rowNumber))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Stellingen van"
    }
  }, [_vm._v("Stellingen van:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.racksFrom),
      expression: "racksFrom"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "placeholder": "01"
    },
    domProps: {
      "value": (_vm.racksFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.racksFrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Stellingen tot"
    }
  }, [_vm._v("Stellingen tot:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.racksTill),
      expression: "racksTill"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "placeholder": "11"
    },
    domProps: {
      "value": (_vm.racksTill)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.racksTill = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.rowNumber && _vm.racksFrom && _vm.racksTill) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.letter))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.rowNumber))]), _vm._v(".\n                          "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.racksFrom))]), _vm._v("-\n                          "), _c('p', [_vm._v(_vm._s(_vm.letter))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.rowNumber))]), _vm._v(".\n                          "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.racksTill))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Planken van"
    }
  }, [_vm._v("Planken van:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planksFrom),
      expression: "planksFrom"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "placeholder": "01"
    },
    domProps: {
      "value": (_vm.planksFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.planksFrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Planken tot"
    }
  }, [_vm._v("Planken tot:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planksTill),
      expression: "planksTill"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "placeholder": "06"
    },
    domProps: {
      "value": (_vm.planksTill)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.planksTill = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.rowNumber && _vm.racksFrom && _vm.racksTill && _vm.planksFrom && _vm.planksTill) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.letter))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.rowNumber))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.racksFrom))]), _vm._v(".\n                          "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.planksFrom))]), _vm._v("-\n                          "), _c('p', [_vm._v(_vm._s(_vm.letter))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.rowNumber))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.racksTill))]), _vm._v(".\n                          "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.planksTill))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Locaties van"
    }
  }, [_vm._v("Locaties van")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationsFrom),
      expression: "locationsFrom"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "placeholder": "01"
    },
    domProps: {
      "value": (_vm.locationsFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.locationsFrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Locaties tot"
    }
  }, [_vm._v("Locaties tot")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationsTill),
      expression: "locationsTill"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "placeholder": "05"
    },
    domProps: {
      "value": (_vm.locationsTill)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.locationsTill = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.rowNumber && _vm.racksFrom && _vm.racksTill && _vm.planksFrom && _vm.planksTill && _vm.locationsTill && _vm.locationsFrom) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.letter))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.rowNumber))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.racksFrom))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.planksFrom))]), _vm._v(".\n                          "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.locationsFrom))]), _vm._v("-\n                          "), _c('p', [_vm._v(_vm._s(_vm.letter))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.rowNumber))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.racksTill))]), _vm._v(".\n                          "), _c('p', [_vm._v(_vm._s(_vm.planksTill))]), _vm._v(".\n                          "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.locationsTill))])]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.generateLocationStickerPdf
    }
  }, [_vm._v("Genereer PDF (" + _vm._s(_vm.totalStickersToBePrinted) + " stickers)")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a70c15c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/products/LocationStickerGenerator.vue
// module id = 747
// module chunks = 1